module.exports = __webpack_public_path__ + "cc2e33e24d5f997b849ec1ec10faace7.png";